;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.routes.invoice.list')
    .controller('InvoiceListToolbarController', InvoiceListToolbarController)

  InvoiceListToolbarController.$inject = [
    // Urls
    'urls',

    // Angular
    '$uibModal', '$http',

    // Services
    'LedgerService', 'InvoiceService', 'FilterService'

  ]

  function InvoiceListToolbarController (
    // Urls
    urls,

    // Angular
    $uibModal, $http,

    // Services
    LedgerService, InvoiceService, FilterService

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes

        // Public Method
        getGeneralLedger: getGeneralLedger,
        exportSearch
      })
    }

    function getGeneralLedger () {
      LedgerService.getGeneralLedger(function (d) {
        LedgerService.displayErrors(d.data)
      })
    }

    function exportSearch () {
      const conditions = FilterService.parseQueryTree(angular.copy(self.$resolve.pagination.search))
      const total = angular.copy(self.$resolve.pagination.totalElements)
      return InvoiceService.searchToSpreadsheet(conditions, total)
    }
  }
})(window.angular, window._, window.moment)
